(function () {
  'use strict';
  if (window.matchMedia('(min-width: 750px)').matches) return;

  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  var anchor = document.getElementById(bar.dataset.anchor);
  if (!anchor) return;

  var barBtn = bar.querySelector('[data-sticky-atc-btn]');
  var barBtnLabel = bar.querySelector('[data-sticky-atc-btn-label]');
  var barPriceEl = bar.querySelector('[data-sticky-atc-price]');
  var priceSrc = document.getElementById(bar.dataset.priceSrc);

  bar.hidden = false;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.removeAttribute('data-visible');
          document.body.removeAttribute('data-sticky-atc-active');
        } else {
          bar.setAttribute('data-visible', '');
          document.body.setAttribute('data-sticky-atc-active', '');
        }
      });
    },
    { rootMargin: '0px 0px -60px 0px', threshold: 0 }
  );
  io.observe(anchor);

  barBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (barBtn.disabled) return;
    anchor.click();
  });

  function sync() {
    barBtn.disabled = anchor.disabled;
    var anchorSpan = anchor.querySelector('span');
    if (anchorSpan && barBtnLabel) {
      barBtnLabel.textContent = anchorSpan.textContent.trim();
    }
    if (priceSrc && barPriceEl) {
      var clone = priceSrc.cloneNode(true);
      clone.removeAttribute('id');
      barPriceEl.innerHTML = '';
      barPriceEl.appendChild(clone);
    }
  }

  var mo = new MutationObserver(sync);
  mo.observe(anchor, {
    attributes: true,
    attributeFilter: ['disabled'],
    childList: true,
    subtree: true,
  });
  if (priceSrc) {
    mo.observe(priceSrc, { childList: true, subtree: true, characterData: true });
  }
})();
